import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e839642a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "breadcrumb-copy-wrapper" }
const _hoisted_2 = { class: "breadcrumb" }
const _hoisted_3 = { class: "overview-text breadcrumb-first" }
const _hoisted_4 = { class: "overview-text" }
const _hoisted_5 = { class: "drop-down-section" }
const _hoisted_6 = { class: "graphs-wrapper-tab1" }
const _hoisted_7 = ["id"]
const _hoisted_8 = { class: "graphs-wrapper" }
const _hoisted_9 = ["id"]
const _hoisted_10 = { class: "graphs-wrapper" }
const _hoisted_11 = ["id"]

import RexTabsV3 from '@/rex-components/RexTabsV3.vue';
import CreateAlert from '@/components/AlertsV2/CreateAlert.vue';
import AddToDashboard from '@/components/Cloud/Dashboard/Components/add-to-dashboard.vue';
import { computed, onMounted, ref, watch, watchEffect } from 'vue';
import { useI18n } from 'vue-i18n';
import cloudTemplate from '@/utils/templates/cloud.template';
import RexSelectV3 from '@/rex-components/RexSelectV3.vue';
import { useStoreDataCloud } from '@/components/Cloud/Dashboard/useStoreData';
import { useStoreData } from '@/components/Common/useStoreData';
import { useRoute } from 'vue-router';
import AwsMetricsGraph from '@/components/Cloud/Dashboard/Components/aws-metrics-graph.vue';
import AwsTiles from '@/components/Cloud/Dashboard/Components/aws-tiles.vue';
import {
  downloadCsv,
  parseServiceObjFromApplication,
} from '@/utils/helper-function';
import { useGetServiceInstances } from '@/components/Cloud/Hooks/useGetServiceInstances';
import {
  elasticacheSubscriptionPageTabs,
  elasticacheTilesHeader,
} from '@/components/Cloud/Dashboard/pages/elasticache/elasticache.types';
import { useMatricesData } from '@/components/Cloud/Hooks/useMetricsData';
import {
  elastiCacheClusterType,
  elastiCacheTabMapper,
  elastiCacheTabHeaderMapper,
  elastiCacheTabMapperEnum,
} from '@/components/Cloud/Dashboard/pages/elasticache/elasticache.types';
import {
  CHILD,
  PARENT,
} from '@/components/Cloud/Dashboard/pages/elasticache/elasticache.constants';
import elastiCacheCharts from '@/utils/templates/cloudTemplates/aws/elasticache.config';
import { usePermissions } from '@/hooks/usePermissions';
import {
  capabilityResourceGroupMap,
  CLOUD_RESOURCE_GROUP,
  HOME_RESOURCE_GROUP,
  permissionTypes,
} from '@/router/constant';


export default /*#__PURE__*/_defineComponent({
  __name: 'subscription-page',
  setup(__props) {

const { t } = useI18n();
const {
  setCurrentServiceInstance,
  setCurrentServices,
  setCurrentPage,
  setCurrentTab,
  getCurrentServiceInstances,
  setCurrentSubType,
  setCurrentAlertCapability,
  setCurrentAlertApplication,
  setAlertApplication,
  setShowAddConfigureAlert,
  getCurrentService,
  getShowAddConfigureAlert,
  setClusterLabels,
  getCurrentServices,
} = useStoreDataCloud();
const { getDurationTime } = useStoreData();
const { params } = useRoute();
const {
  data: instances,
  fetchServiceInstances,
  isLoading: isInstancesLoading,
} = useGetServiceInstances({
  serviceId: params.serviceId,
});
const { subscriptionMatrices, fetchMatrices } = useMatricesData({
  headers: ref(elasticacheTilesHeader()),
  subscriptions: ref([{ key: params.serviceId as string }] as any),
});

const selectedTab = ref('1');
const graphLegends = ref('');
const addToDashboardChartConfig = ref<any>({});
const metricNameForAddToDashboard = ref('');
const showAddToDashboard = ref(false);
const tempEntityId = ref<any[]>([]);
const getElasticacheInstancesForAlerts = ref<any[]>([]);

const currentTab = computed(() => {
  const tabMapper = {
    1: 'host',
    2: 'REDIS',
    3: 'MEMC',
  };

  return tabMapper[selectedTab.value];
});

const filterInstancesByTab = (instance, currentTab, filterFor) => {
  if (currentTab === 'host') {
    return instance.metaProperty1 === filterFor;
  }

  return (
    instance.metaProperty1 === filterFor && instance.instanceType === currentTab
  );
};

const onTabChange = (key) => {
  const currentTab = elastiCacheTabMapper[key];

  selectedCacheList.value = instances.value
    .filter((instance) => {
      return filterInstancesByTab(
        instance,
        currentTab,
        elastiCacheClusterType.parent,
      );
    })
    .map((instance) => instance.key)
    .slice(0, 1);

  setCurrentTab(elasticacheSubscriptionPageTabs[key - 1].label);
  selectedTab.value = key;
};

const getGraphTemplate = computed(() => {
  return elastiCacheCharts()[
    `${elastiCacheTabHeaderMapper[selectedTab.value].toLowerCase()}`
  ];
});
const isLoading = computed(() => isInstancesLoading);

const tilesData = computed(() => {
  return elasticacheTilesHeader()
    .map((item) => {
      if (!subscriptionMatrices.value[0]) {
        return undefined;
      }
      if (item.key in subscriptionMatrices.value[0]) {
        return {
          title: item.tileName,
          content: subscriptionMatrices.value[0][item.key],
          tooltip: item.tooltip,
        };
      }
    })
    .filter((item) => item);
});

onMounted(() => {
  setCurrentPage('subscriptionId');
  setCurrentTab('Host');
  fetchServiceInstances();
  fetchMatrices();
});

watch(getDurationTime, () => {
  fetchMatrices();
});

const getMoreOptionsData = (graphIndex, chartConfig) => {
  const { hasCapabilityAlertWritePermission, hasCapabilityWritePermission } =
    usePermissions();

  const hasAlertWrite = hasCapabilityAlertWritePermission(
    capabilityResourceGroupMap[CLOUD_RESOURCE_GROUP],
  );

  const allowHome =
    hasCapabilityWritePermission(
      capabilityResourceGroupMap[HOME_RESOURCE_GROUP],
    ) &&
    hasCapabilityWritePermission(
      capabilityResourceGroupMap[CLOUD_RESOURCE_GROUP],
    );

  return [
    ...(allowHome
      ? [
          {
            id: 2,
            label: t('aws.addToDashboard'),
            callBack: (options) => {
              metricNameForAddToDashboard.value =
                getGraphTemplate.value?.[graphIndex].metricName || '';
              chartConfig.aggregationInfo = {
                aggregation: chartConfig.aggregation,
                aggregationNum: chartConfig.aggregationNum,
              };
              addToDashboardChartConfig.value = chartConfig;
              showAddToDashboard.value = true;
            },
          },
        ]
      : []),
    ...(hasAlertWrite
      ? [
          {
            id: 3,
            label: t('aws.createAlert'),
            callBack: (options) => {
              metricNameForAddToDashboard.value =
                getGraphTemplate.value?.[graphIndex].metricName || '';
              setCurrentSubType('ELASTICACHE');
              setCurrentAlertCapability({
                key: 'CAPABILITY_CLOUD',
                label: 'Cloud monitoring',
              });
              const subscriptionId = parseServiceObjFromApplication({
                key: getCurrentService.value,
                label: '',
              }).name;
              const keyLabel = {
                key: params.serviceId,
                label: subscriptionId,
                permissions: permissionTypes.ALERT_WRITE,
              };
              setCurrentAlertApplication(keyLabel);
              setAlertApplication([keyLabel]);
              setShowAddConfigureAlert(true);
            },
          },
        ]
      : []),
    {
      id: 4,
      label: t('aws.downloadAsCsv'),
      callBack: (options) => {
        downloadCsv({
          options,
          params,
          getDurationTime,
        });
      },
    },
  ];
};

const getInstances = (isMultiMetric) => {
  if (isMultiMetric) {
    return filterAndMapInstances(
      (instance) =>
        filterInstancesByTab(instance, currentTab.value, CHILD) &&
        tempEntityId.value.includes(instance.key),
      (instance) => {
        return {
          value: instance.key,
          keyLabel: instance.label,
        };
      },
    );
  }
  return filterAndMapInstances(
    (instance) =>
      filterInstancesByTab(instance, currentTab.value, PARENT) &&
      selectedCacheList.value.includes(instance.key),
    (instance) => {
      return {
        value: instance.key,
        keyLabel: instance.label,
      };
    },
  );
};

const selectedCacheList = ref<string[]>([]);
const cacheLists = ref<
  { key: string; label: string; value: string; instanceType: string }[]
>([]);

const onOptionSelect = (value, options) => {
  if (options.length > 5) {
    return;
  }
  selectedCacheList.value = options.map((option) => option.value);

  const filteredClusters = filterAndMapInstances(
    (instance) =>
      filterInstancesByTab(instance, currentTab.value, PARENT) &&
      value.includes(instance.key),
    (instance) => {
      return instance.key;
    },
  );
  const filteredClusterLabels = filterAndMapInstances(
    (instance) =>
      filterInstancesByTab(instance, currentTab.value, PARENT) &&
      value.includes(instance.key),
    (instance) => instance.label,
  );
  tempEntityId.value = filterAndMapInstances(
    (instance) =>
      filterInstancesByTab(instance, currentTab.value, CHILD) &&
      value.includes(instance.parentEntityId),
    (instance) => {
      return instance.key;
    },
  );

  const filteredNodes = filterAndMapInstances(
    (instance) =>
      filterInstancesByTab(instance, currentTab.value, CHILD) &&
      value.includes(instance.parentEntityId),
    (instance) => {
      return instance.key;
    },
  );

  graphLegends.value = filterAndMapInstances(
    (instance) =>
      filterInstancesByTab(instance, currentTab.value, CHILD) &&
      value.includes(instance.parentEntityId),
    (instance) => instance.label,
  ).join(', ');

  setCurrentServiceInstance(filteredNodes);
  setCurrentServices(filteredClusters);
  setClusterLabels(filteredClusterLabels);
};

const computedCacheList = computed(() => {
  if (currentTab.value === 'host') {
    return cacheLists.value;
  }

  return cacheLists.value.filter((instance) => {
    return instance.instanceType === currentTab.value;
  });
});

const filterAndMapInstances = (filterFunction, mapperCallback) => {
  return instances.value.filter(filterFunction).map(mapperCallback);
};

watch([instances, selectedTab], (currentValue, oldValue) => {
  const filteredClusters = filterAndMapInstances(
    (instance) => filterInstancesByTab(instance, currentTab.value, PARENT),
    (instance) => {
      return instance.key;
    },
  ).slice(0, 1);

  const initialRenderCluster = filterAndMapInstances(
    (instance) => filterInstancesByTab(instance, currentTab.value, PARENT),
    (instance) => {
      return instance.key;
    },
  ).slice(0, 1);

  const filteredClusterLabels = filterAndMapInstances(
    (instance) => filterInstancesByTab(instance, currentTab.value, PARENT),
    (instance) => instance.label,
  ).slice(0, 1);

  tempEntityId.value = filterAndMapInstances(
    (instance) =>
      filterInstancesByTab(instance, currentTab.value, CHILD) &&
      initialRenderCluster.includes(instance.parentEntityId),
    (instance) => {
      return instance.key;
    },
  );

  const filteredNodes = filterAndMapInstances(
    (instance) => {
      return (
        filterInstancesByTab(instance, currentTab.value, CHILD) &&
        initialRenderCluster.includes(instance.parentEntityId)
      );
    },
    (instance) => {
      return instance.key;
    },
  );

  graphLegends.value = filterAndMapInstances(
    (instance) =>
      filterInstancesByTab(instance, currentTab.value, CHILD) &&
      initialRenderCluster.includes(instance.parentEntityId),
    (instance) => instance.label,
  ).join(', ');

  setCurrentServiceInstance(filteredNodes);
  setCurrentServices(filteredClusters);
  setClusterLabels(filteredClusterLabels);
});

const computedTabs = computed(() => {
  const instanceTypeSet = new Set(
    instances.value
      ?.filter((instance) => instance.metaProperty1 === PARENT)
      ?.map((instance) => instance.instanceType.toLowerCase()),
  );
  return elasticacheSubscriptionPageTabs.map((tab) => {
    return {
      ...tab,
      disabled:
        tab.slug === 'host'
          ? false
          : !Array.from(instanceTypeSet).includes(tab.slug.toLowerCase()),
    };
  });
});

watch(instances, () => {
  cacheLists.value = instances.value
    .filter((instance) => instance.metaProperty1 === 'parent')
    .map((instance) => ({
      label: instance.label,
      value: instance.key,
      key: instance.key,
      instanceType: instance.instanceType,
    }));

  selectedCacheList.value = cacheLists.value
    .map((instance) => instance.key)
    .slice(0, 1);
});

const getECAInstancesForAlerts = () => {
  getElasticacheInstancesForAlerts.value = cacheLists.value.map((instance) => {
    const selected = selectedCacheList.value.includes(instance.key);
    return { key: instance.key, label: instance.label, selected };
  });
};
watch(getShowAddConfigureAlert, getECAInstancesForAlerts);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_RexSelectOption = _resolveComponent("RexSelectOption")!
  const _component_RexSpinV3 = _resolveComponent("RexSpinV3")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h4", _hoisted_3, [
          _createVNode(_component_router_link, {
            to: { name: 'awsoverview' },
            class: "breadcrumb-link"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('aws.overviewText')), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("h4", _hoisted_4, _toDisplayString(_unref(params).subscriptionId), 1)
      ])
    ]),
    _createVNode(_component_RexSpinV3, { spinning: isLoading.value }, {
      default: _withCtx(() => [
        _createVNode(AwsTiles, {
          numberOfRows: 1,
          tiles: tilesData.value
        }, null, 8, ["tiles"]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h4", null, _toDisplayString(_unref(t)('aws.selectCache')), 1),
          _createVNode(RexSelectV3, {
            mode: "multiple",
            maxTagTextLength: 12,
            maxTagCount: 1,
            value: selectedCacheList.value,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((selectedCacheList).value = $event)),
            options: computedCacheList.value,
            onOnChange: onOptionSelect,
            class: "capability-dropdown",
            id: "search-select-functions"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(computedCacheList.value, (obj) => {
                return (_openBlock(), _createBlock(_component_RexSelectOption, {
                  key: obj.key,
                  value: obj.label
                }, null, 8, ["value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["value", "options"])
        ]),
        _createVNode(RexTabsV3, {
          tabs: computedTabs.value,
          onOnTabChange: onTabChange,
          activeKey: selectedTab.value
        }, {
          "tab-1": _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getGraphTemplate.value, (chartConfig, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "chart-element",
                  key: index,
                  style: _normalizeStyle({ width: chartConfig.width }),
                  id: 'graph-' + index
                }, [
                  _createVNode(AwsMetricsGraph, {
                    sliceGraphLabels: true,
                    showMoreOptions: "",
                    moreOptionsData: getMoreOptionsData(index, chartConfig),
                    graphConfig: chartConfig,
                    index: index,
                    label: graphLegends.value
                  }, null, 8, ["moreOptionsData", "graphConfig", "index", "label"])
                ], 12, _hoisted_7))
              }), 128))
            ])
          ]),
          "tab-2": _withCtx(() => [
            _createElementVNode("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getGraphTemplate.value, (chartConfig, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "chart-element",
                  key: index,
                  style: _normalizeStyle({ width: chartConfig.width }),
                  id: 'graph-' + index
                }, [
                  _createVNode(AwsMetricsGraph, {
                    sliceGraphLabels: true,
                    showMoreOptions: "",
                    moreOptionsData: getMoreOptionsData(index, chartConfig),
                    graphConfig: chartConfig,
                    index: index,
                    label: graphLegends.value
                  }, null, 8, ["moreOptionsData", "graphConfig", "index", "label"])
                ], 12, _hoisted_9))
              }), 128))
            ])
          ]),
          "tab-3": _withCtx(() => [
            _createElementVNode("div", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getGraphTemplate.value, (chartConfig, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "chart-element",
                  key: index,
                  style: _normalizeStyle({ width: chartConfig.width }),
                  id: 'graph-' + index
                }, [
                  _createVNode(AwsMetricsGraph, {
                    sliceGraphLabels: true,
                    showMoreOptions: "",
                    moreOptionsData: getMoreOptionsData(index, chartConfig),
                    graphConfig: chartConfig,
                    index: index,
                    label: graphLegends.value
                  }, null, 8, ["moreOptionsData", "graphConfig", "index", "label"])
                ], 12, _hoisted_11))
              }), 128))
            ])
          ]),
          _: 1
        }, 8, ["tabs", "activeKey"]),
        (_unref(getShowAddConfigureAlert))
          ? (_openBlock(), _createBlock(CreateAlert, {
              key: 0,
              instancesProp: getElasticacheInstancesForAlerts.value,
              metricNameProp: metricNameForAddToDashboard.value,
              instancePropType: "function"
            }, null, 8, ["instancesProp", "metricNameProp"]))
          : _createCommentVNode("", true),
        (showAddToDashboard.value)
          ? (_openBlock(), _createBlock(AddToDashboard, {
              key: 1,
              chartConfig: addToDashboardChartConfig.value,
              "metric-name": metricNameForAddToDashboard.value,
              onOnClose: _cache[1] || (_cache[1] = () => (showAddToDashboard.value = false)),
              showAddToDashboard: showAddToDashboard.value,
              instances: getInstances(addToDashboardChartConfig.value.isMultiMetric)
            }, null, 8, ["chartConfig", "metric-name", "showAddToDashboard", "instances"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["spinning"])
  ], 64))
}
}

})